<template>
  <div class="progress">
    <h2 class="progress__title">{{ $t('3D Search Engine') }}</h2>
    <p v-if="loadingProgress === ''" class="progress__text">{{ $t(text) }}{{ dots }}</p>
    <p v-else class="progress__text">{{ $t(text) }} {{ loadingProgress }}</p>

    <div class="boxes">
      <div class="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    loadingProgress: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      text: 'Loading',
      dots: '',
    }
  },
  mounted() {
    this.updateDots()
  },
  methods: {
    updateDots() {
      setTimeout(() => {
        if (this.dots.length < 3) {
          this.dots += `.`
        } else {
          this.dots = ``
        }

        this.updateDots()
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/ProgressBar.scss';
</style>
